module.exports = __webpack_public_path__ + "static/media/PolarDrift_HoverVehicle.8c8d33c6.gif";